<div class="text-center">
  <!-- description -->
  <!-- injected description -->
  <div #injectDescription>
    <ng-content select="[description]"></ng-content>
  </div>
  <!-- default description -->
  @if (injectDescription.children.length === 0) {
    <div>
      <div
        [ngClass]="type === 'multichain' ? 'multichain-header' : ''"
        class="text-big-black font-size-24 mb-10 mt-20 large-weight"
        >{{ "two_factor_header" | translate }}</div
        >
        <div [ngClass]="type === 'multichain' ? 'multichain-subtitle' : ''" class="mb-15 text-medium-black">{{
          type === "multichain"
          ? ("two-fa-multichain-subtitle" | translate)
          : ("please_enter_your_2fa_code" | translate)
        }}</div>
        @if (type !== 'multichain') {
          <div class="mb-40 font-size-14">
            <a [href]="getAuthenticatorLink()" [target]="'_blank'">{{ "authenticator_access_lost" | translate }}</a>
          </div>
        }
      </div>
    }
    <!-- input -->
    <div>
      <span class="mb-10">
        <input
          [ngClass]="type === 'multichain' ? 'multichain-input' : ''"
          class="form-field-enhanced mod-two-fa input-lg"
          name="deposit-2fa"
          bp-type="2fa"
          [formatted-output]="false"
          [focus]="true"
          [(ngModel)]="authCode"
          (input)="autoAccept()"
          [disabled]="isInputDisabled"
          [placeholder]="'security_settings_2fa_enable_modal_step_input_pin_code_placeholder' | translate" />
      </span>
    </div>

    @if (type === 'multichain') {
      <div class="mb-80 font-size-14 multichain-link">
        <a [href]="getAuthenticatorLink()" [target]="'_blank'">{{ "authenticator_access_lost" | translate }}</a>
      </div>
    }
  </div>
